(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/play/assets/javascripts/pickers/bet-mode-picker.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/play/assets/javascripts/pickers/bet-mode-picker.js');

'use strict';

const RadioGroup = svs.ui.form.RadioGroup;
const RadioButton = svs.ui.form.RadioButton;
const BetModePicker = props => React.createElement("div", {
  className: "bet-mode-picker-holder"
}, React.createElement("div", {
  className: "picker-header"
}, React.createElement("span", null, "V\xE4lj hur du vill spela")), React.createElement("div", {
  className: "bet-mode-picker form-toggle-racing"
}, React.createElement(RadioGroup, {
  multipleLines: true,
  size: "200",
  thin: true
}, React.createElement(RadioButton, {
  branding: "racing",
  checked: props.isXpert,
  key: "bet-mode-picker-xpert",
  name: "toggle-radio-group-bet-mode-picker",
  onChange: () => props.setIsXpert(true),
  value: "1"
}, "PIX! F\xE4rdiga spel"), React.createElement(RadioButton, {
  branding: "racing",
  checked: !props.isXpert,
  key: "bet-mode-picker-regular",
  name: "toggle-radio-group-bet-mode-picker",
  onChange: () => props.setIsXpert(false),
  value: "0"
}, "Eget spel"))));
svs.racing_game.components.play.BetModePicker = BetModePicker;

 })(window);